<template>
	<div class="total-container" v-if="articles.length > 0">
		<v-card elevation="10" color="#005CB9" class="white--text">
			<v-card-title
				:class="[
					'd-flex',
					'align-center',
					$vuetify.breakpoint.smAndDown
						? 'justify-space-between'
						: 'justify-space-between pa-2 pl-7 pr-7',
				]"
			>
				<div
					:class="[
						'd-flex',
						$vuetify.breakpoint.smAndDown
							? 'flex-column justify-center'
							: 'align-center justify-space-between',
					]"
					style="width: 100%;"
				>
					<small>
						Resumen de compra:
					</small>

					<div
						:class="[
							'd-flex',
							'align-center',
							{
								'justify-space-between':
									$vuetify.breakpoint.smAndDown,
							},
						]"
					>
						<small>
							{{ `Total: ${priceFormat(getTotal)} MXN` }}
						</small>

						<v-btn
							fab
							class="ml-10"
							@click="ui.show = !ui.show"
							:small="$vuetify.breakpoint.mdAndUp"
						>
							<v-icon>
								{{
									ui.show
										? "mdi-chevron-down"
										: "mdi-chevron-up"
								}}
							</v-icon>
						</v-btn>
					</div>
				</div>
			</v-card-title>
			<v-card-text v-if="ui.show">
				<v-divider dark></v-divider>
				<v-container fluid>
					<v-row justify="end" class="white--text">
						<v-col cols="12" md="4">
							<v-row>
								<v-col
									cols="7"
									class="pt-0 pb-0 d-flex justify-end"
								>
									Subtotal:
								</v-col>
								<v-col
									cols="5"
									class="pt-0 pb-0 d-flex justify-end"
								>
									{{ `${priceFormat(getSubTotal)}` }}
								</v-col>
							</v-row>
							<v-row>
								<v-col
									cols="7"
									class="pt-0 pb-0 d-flex justify-end"
								>
									{{
										`Descuento de socio(${getMemberDiscount}%):`
									}}
								</v-col>
								<v-col
									cols="5"
									class="pt-0 pb-0 d-flex justify-end"
								>
									<span>
										{{ `${priceFormat(getDiscount)}` }}
									</span>
								</v-col>
							</v-row>
							<v-row>
								<v-col
									cols="7"
									class="pt-0 pb-0 d-flex justify-end"
								>
									IVA:
								</v-col>
								<v-col
									cols="5"
									class="pt-0 pb-0 d-flex justify-end"
								>
									{{ `${priceFormat(getIva)}` }}
								</v-col>
							</v-row>
						</v-col>

						<v-col
							cols="12"
							md="3"
							class="d-flex align-center justify-center"
						>
							<v-btn
								@click="send()"
								large
								:block="$vuetify.breakpoint.smAndDown"
							>
								enviar orden de compra
							</v-btn>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Article from "@/clas/Article";
import { EventBus } from "@/main";

export default {
	name: "BottomBar",

	data() {
		return {
			ui: {
				show: false,
			},
		};
	},

	methods: {
		priceFormat(val) {
			let a = new Article();

			return a.priceFormat(val);
		},

		send() {
			this.ui.show = false;

			EventBus.$emit("PurchaceOrderCreate");
		},
	},

	computed: {
		...mapGetters({
			getIva: "cart/getIva",
			getTotal: "cart/getTotal",
			getDiscount: "cart/getDiscount",
			getSubTotal: "cart/getSubTotal",
			getArticles: "cart/getArticles",
			getMemberDiscount: "getMemberDiscount",
		}),

		articles() {
			return this.getArticles;
		},
	},
};
</script>

<style lang="css" scoped>
.total-container {
	position: fixed;
	bottom: 0;
	width: 90%;
	left: 5%;
	z-index: 10;
	background-color: transparent;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 600px) {
	.total-container {
		left: 0;
		width: 100%;
	}
}

/*Small	sm	Small to medium tablet	600px > < 960px*/
@media (min-width: 601px) and (max-width: 960px) {
	.total-container {
		left: 0;
		width: 100%;
	}
}
</style>
